import React, { useState, useEffect } from 'react';
import { getPendingJobs, verifyJob, deleteJob } from '../../services/adminApi';
import './JobsList.css'; // Reuse styles but with moderation tweaks

const JobsModeration = () => {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [processingId, setProcessingId] = useState(null);

    useEffect(() => {
        loadPendingJobs();
    }, []);

    const loadPendingJobs = async () => {
        try {
            setLoading(true);
            const data = await getPendingJobs();
            setJobs(data);
        } catch (error) {
            console.error('Error loading pending jobs:', error);
            alert('Не удалось загрузить вакансии на модерацию');
        } finally {
            setLoading(false);
        }
    };

    const handleVerify = async (id) => {
        setProcessingId(id);
        try {
            await verifyJob(id);
            setJobs(jobs.filter(j => j.ID !== id));
            alert('Вакансия одобрена и опубликована!');
        } catch (error) {
            console.error('Error verifying job:', error);
            alert('Ошибка при одобрении вакансии');
        } finally {
            setProcessingId(null);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Вы уверены, что хотите отклонить и удалить эту вакансию?')) {
            return;
        }

        setProcessingId(id);
        try {
            await deleteJob(id);
            setJobs(jobs.filter(j => j.ID !== id));
            alert('Вакансия отклонена и удалена');
        } catch (error) {
            console.error('Error deleting job:', error);
            alert('Ошибка при удалении вакансии');
        } finally {
            setProcessingId(null);
        }
    };

    const cleanText = (text) => {
        if (!text) return '';
        return String(text)
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&amp;/g, '&');
    };

    if (loading) {
        return <div className="loading">Загрузка вакансий на модерацию...</div>;
    }

    return (
        <div className="admin-jobs-list moderation-list">
            <div className="list-header">
                <h2>Модерация вакансий ({jobs.length})</h2>
            </div>

            {jobs.length === 0 ? (
                <div className="empty-state" style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                    <p>Нет вакансий, ожидающих проверки.</p>
                </div>
            ) : (
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th className="col-id">ID</th>
                                <th className="col-name">Название</th>
                                <th className="col-desc">Описание</th>
                                <th className="col-user">Автор</th>
                                <th className="col-date">Дата создания</th>
                                <th className="col-img">Изображение</th>
                                <th className="col-actions">Действия</th>
                            </tr>
                        </thead>
                        <tbody>
                            {jobs.map((job) => (
                                <tr key={job.ID}>
                                    <td className="col-id">{job.ID}</td>
                                    <td className="col-name" style={{ verticalAlign: 'top' }}>
                                        <strong>{job.NAME}</strong>
                                        <div className="code-preview" style={{ fontSize: '11px', color: '#888' }}>{job.CODE}</div>
                                    </td>
                                    <td className="col-desc" style={{ maxWidth: '400px', fontSize: '12px', verticalAlign: 'top' }}>
                                        <div className="preview-text" style={{ marginBottom: '10px' }}>
                                            <strong>Кратко:</strong>
                                            <div dangerouslySetInnerHTML={{ __html: cleanText(job.PREVIEW_TEXT) }} />
                                        </div>
                                        {job.DETAIL_TEXT && (
                                            <div className="detail-text">
                                                <strong>Полное:</strong>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: cleanText(job.DETAIL_TEXT) }}
                                                    style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #444', padding: '8px', borderRadius: '4px', background: '#333' }}
                                                />
                                            </div>
                                        )}
                                    </td>
                                    <td className="col-user" style={{ verticalAlign: 'top' }}>
                                        {job.USER_NAME || job.USER_LOGIN || 'Аноним'}
                                    </td>
                                    <td className="col-date" style={{ verticalAlign: 'top' }}>
                                        {new Date(job.DATE_CREATE).toLocaleDateString()}
                                    </td>
                                    <td className="col-img" style={{ verticalAlign: 'top' }}>
                                        {job.PREVIEW_PICTURE_SRC && (
                                            <img
                                                src={`${process.env.REACT_APP_BACKEND_URL || 'https://www.kapussta.com'}${job.PREVIEW_PICTURE_SRC}`}
                                                alt={job.NAME}
                                                className="thumbnail"
                                            />
                                        )}
                                    </td>
                                    <td className="col-actions" style={{ verticalAlign: 'top' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <button
                                                onClick={() => handleVerify(job.ID)}
                                                className="btn-edit"
                                                style={{ backgroundColor: '#2ecc71', width: '100%', margin: 0 }}
                                                disabled={processingId === job.ID}
                                            >
                                                {processingId === job.ID ? '...' : 'Одобрить'}
                                            </button>
                                            <button
                                                onClick={() => handleDelete(job.ID)}
                                                className="btn-delete"
                                                style={{ width: '100%', margin: 0 }}
                                                disabled={processingId === job.ID}
                                            >
                                                {processingId === job.ID ? '...' : 'Отклонить'}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default JobsModeration;
